import {
    Box, Stack, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    IconButton, Select, MenuItem, Tooltip, Button, CircularProgress, Checkbox
} from "@mui/material";
import { Check, Close, Edit, Add } from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { helper } from "../../../../utils/helper.js";

const COL_HEADER_SX = {
    fontSize: "9px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "#6b7280",
    textAlign: "center",
    padding: "8px 6px",
};

const ENGINE_VALUE_SX = {
    fontWeight: 700,
    fontSize: "14px",
    color: "#3b82f6",
    fontFamily: "monospace",
    background: "#eff6ff",
    borderRadius: "6px",
    padding: "4px 8px",
    display: "inline-block",
};

const WASH_VALUE_SX = {
    fontWeight: 700,
    fontSize: "14px",
    color: "#374151",
    fontFamily: "monospace",
};

export default function EquipageTimesheetTable({
    data,
    isEditingStart, isEditingEnd, isEditingPause,
    heureDebutValue, heureFinValue, pauseValue,
    heureDebutBinome, heureFinBinome, pauseBinome,
    isEditingStartBinome, isEditingEndBinome, isEditingPauseBinome,
    hasDifference,
    pauseData,
    engineTimesDebut, engineTimesFin,
    binomeEngineTimesDebut, binomeEngineTimesFin,
    isUpdatingPanier,
    handleEditClick, handleSave, handleCancel,
    handlePanierRepasToggle, handleCreateBinomeFdt,
    isLoading,
    renderLaveuseTimes,
    helper: helperProp,
    posteOperateurId,
    setHeureDebutValue, setHeureFinValue, setPauseValue,
    setHeureDebutBinome, setHeureFinBinome, setPauseBinome,
}) {
    const h = helperProp || helper;

    return (
        <Box sx={{ background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: "10px", overflow: "hidden" }}>
            <Table size="small">
                <TableHead>
                    <TableRow sx={{ background: "#f1f5f9", borderBottom: "1px solid #e5e7eb" }}>
                        <TableCell sx={COL_HEADER_SX}>Opérateur</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Démarrage camion</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Prise de poste</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Premier lavage</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Temps de pause</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Dernier lavage</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Fin de poste</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Arrêt camion</TableCell>
                        <TableCell sx={COL_HEADER_SX}>Panier repas</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Ligne chauffeur */}
                    <TableRow>
                        <TableCell align="center">
                            <Typography fontWeight={700} fontSize="13px">{data.operateur.libelle}</Typography>
                            <Typography variant="caption" color="text.secondary">({data.role})</Typography>
                            <Typography variant="caption" sx={{ display: "block", color: "#9ca3af" }}>(id {data.feuilleDeTemps?.id})</Typography>
                        </TableCell>

                        {/* Démarrage camion */}
                        <TableCell align="center">
                            {engineTimesDebut ? (
                                <Typography sx={ENGINE_VALUE_SX}>{engineTimesDebut}</Typography>
                            ) : (
                                <Typography sx={{ ...ENGINE_VALUE_SX, color: "#9ca3af", background: "transparent" }}>—</Typography>
                            )}
                        </TableCell>

                        {/* Prise de poste */}
                        <TableCell align="center" sx={hasDifference.debut ? { backgroundColor: "rgba(187,34,34,0.7)" } : {}}>
                            <Box display="flex" flexDirection="column" alignItems="center" gap="3px">
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    {isEditingStart ? (
                                        <>
                                            <DateTimePicker
                                                label="Heure de début"
                                                value={heureDebutValue}
                                                onChange={(v) => setHeureDebutValue(v)}
                                                renderInput={(params) => <TextField {...params} size="small" style={{ width: "175px" }} />}
                                                sx={{ minWidth: "175px" }}
                                            />
                                            <IconButton onClick={() => handleSave("start")} color="secondary" size="small"><Check /></IconButton>
                                            <IconButton onClick={() => handleCancel("start")} color="red" size="small"><Close /></IconButton>
                                        </>
                                    ) : (
                                        <>
                                            {heureDebutValue ? h.getFormattedTime(heureDebutValue) : "-"}
                                            <IconButton onClick={() => handleEditClick("start")} size="small" color="primary"><Edit /></IconButton>
                                        </>
                                    )}
                                </Box>
                                {data.feuilleDeTemps?.debutScannedAt && (
                                    <Typography sx={{ fontSize: "9px", color: "#8b5cf6" }}>
                                        scan: {h.getFormattedTime(data.feuilleDeTemps.debutScannedAt)}
                                    </Typography>
                                )}
                            </Box>
                        </TableCell>

                        {/* Premier lavage */}
                        <TableCell align="center">
                            <Typography sx={WASH_VALUE_SX}>
                                {data.feuilleDeTemps?.premiereIntervention ? h.getFormattedTime(data.feuilleDeTemps.premiereIntervention) : "-"}
                            </Typography>
                        </TableCell>

                        {/* Pause */}
                        <TableCell align="center" sx={hasDifference.pause ? { backgroundColor: "rgba(187,34,34,0.7)" } : {}}>
                            {isEditingPause ? (
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    <Select size="small" value={pauseValue} onChange={(e) => setPauseValue(e.target.value)} style={{ width: "130px" }}>
                                        {pauseData.map((p) => <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>)}
                                    </Select>
                                    <IconButton onClick={() => handleSave("pause")} color="secondary" size="small"><Check /></IconButton>
                                    <IconButton onClick={() => handleCancel("pause")} color="red" size="small"><Close /></IconButton>
                                </Box>
                            ) : (
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    {pauseData.find(p => p.value === pauseValue)?.label || "N/A"}
                                    <IconButton onClick={() => handleEditClick("pause")} size="small" color="primary"><Edit /></IconButton>
                                </Box>
                            )}
                        </TableCell>

                        {/* Dernier lavage */}
                        <TableCell align="center">
                            <Typography sx={WASH_VALUE_SX}>
                                {data.feuilleDeTemps?.derniereIntervention ? h.getFormattedTime(data.feuilleDeTemps.derniereIntervention) : "-"}
                            </Typography>
                        </TableCell>

                        {/* Fin de poste */}
                        <TableCell align="center" sx={hasDifference.fin ? { backgroundColor: "rgba(187,34,34,0.7)" } : {}}>
                            <Box display="flex" flexDirection="column" alignItems="center" gap="3px">
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    {isEditingEnd ? (
                                        <>
                                            <DateTimePicker
                                                label="Heure de fin"
                                                value={heureFinValue}
                                                onChange={(v) => setHeureFinValue(v)}
                                                renderInput={(params) => <TextField {...params} size="small" style={{ width: "130px" }} />}
                                            />
                                            <IconButton onClick={() => handleSave("end")} color="secondary" size="small"><Check /></IconButton>
                                            <IconButton onClick={() => handleCancel("end")} color="red" size="small"><Close /></IconButton>
                                        </>
                                    ) : (
                                        <>
                                            {heureFinValue ? h.getFormattedTime(heureFinValue) : "N/A"}
                                            <IconButton onClick={() => handleEditClick("end")} size="small" color="primary"><Edit /></IconButton>
                                        </>
                                    )}
                                </Box>
                                {data.feuilleDeTemps?.finScannedAt && (
                                    <Typography sx={{ fontSize: "9px", color: "#8b5cf6" }}>
                                        scan: {h.getFormattedTime(data.feuilleDeTemps.finScannedAt)}
                                    </Typography>
                                )}
                            </Box>
                        </TableCell>

                        {/* Arrêt camion */}
                        <TableCell align="center">
                            {engineTimesFin ? (
                                <Typography sx={ENGINE_VALUE_SX}>{engineTimesFin}</Typography>
                            ) : (
                                <Typography sx={{ ...ENGINE_VALUE_SX, color: "#9ca3af", background: "transparent" }}>—</Typography>
                            )}
                        </TableCell>

                        {/* Panier repas */}
                        <TableCell align="center">
                            <Checkbox
                                checked={!!data?.panierRepas}
                                onChange={(e) => handlePanierRepasToggle(e.target.checked, posteOperateurId)}
                                disabled={isUpdatingPanier}
                                inputProps={{ 'aria-label': 'Panier repas' }}
                            />
                        </TableCell>
                    </TableRow>

                    {/* Ligne binôme */}
                    {data.binome && (
                        <TableRow>
                            <TableCell align="center">
                                <Typography fontWeight={700} fontSize="13px">{data.binome.libelle}</Typography>
                                <Typography variant="caption" color="text.secondary">({data.binome.role})</Typography>
                                <Typography variant="caption" sx={{ display: "block", color: "#9ca3af" }}>(id {data.binome.feuilleDeTemps?.id})</Typography>
                            </TableCell>

                            <TableCell align="center">
                                {binomeEngineTimesDebut ? (
                                    <Typography sx={ENGINE_VALUE_SX}>{binomeEngineTimesDebut}</Typography>
                                ) : (
                                    renderLaveuseTimes(data.binome.laveusePrisePoste, data.binome.laveuseFinPoste, binomeEngineTimesDebut, binomeEngineTimesFin, true)
                                )}
                            </TableCell>

                            <TableCell align="center" sx={hasDifference.debut ? { backgroundColor: "rgba(187,34,34,0.7)" } : {}}>
                                {data?.binome?.feuilleDeTemps ? (
                                    <Box display="flex" alignItems="center" justifyContent="center">
                                        {isEditingStartBinome ? (
                                            <>
                                                <DateTimePicker
                                                    label="Heure de début"
                                                    value={heureDebutBinome}
                                                    onChange={(v) => setHeureDebutBinome(v)}
                                                    renderInput={(params) => <TextField {...params} size="small" style={{ width: "175px" }} />}
                                                    sx={{ minWidth: "175px" }}
                                                />
                                                <IconButton onClick={() => handleSave("start", true)} color="secondary" size="small"><Check /></IconButton>
                                                <IconButton onClick={() => handleCancel("start", true)} color="red" size="small"><Close /></IconButton>
                                            </>
                                        ) : (
                                            <>
                                                {heureDebutBinome ? h.getFormattedTime(heureDebutBinome) : "-"}
                                                <IconButton onClick={() => handleEditClick("start", true)} size="small" color="primary"><Edit /></IconButton>
                                            </>
                                        )}
                                    </Box>
                                ) : (
                                    <Box display="flex" alignItems="center" justifyContent="center">
                                        <Tooltip title="Créer une feuille de temps pour le binôme avec les heures du chauffeur">
                                            <Button variant="contained" color="primary" size="small" onClick={handleCreateBinomeFdt} startIcon={<Add />} disabled={isLoading}>
                                                {isLoading ? <CircularProgress size={24} /> : "Créer FDT"}
                                            </Button>
                                        </Tooltip>
                                    </Box>
                                )}
                            </TableCell>

                            <TableCell align="center">
                                <Typography sx={WASH_VALUE_SX}>
                                    {data.binome.feuilleDeTemps?.premiereIntervention ? h.getFormattedTime(data.binome.feuilleDeTemps.premiereIntervention) : "-"}
                                </Typography>
                            </TableCell>

                            <TableCell align="center" sx={hasDifference.pause ? { backgroundColor: "rgba(187,34,34,0.7)" } : {}}>
                                {data?.binome?.feuilleDeTemps ? (
                                    isEditingPauseBinome ? (
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <Select size="small" value={pauseBinome} onChange={(e) => setPauseBinome(e.target.value)} style={{ width: "130px" }}>
                                                {pauseData.map((p) => <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>)}
                                            </Select>
                                            <IconButton onClick={() => handleSave("pause", true)} color="secondary" size="small"><Check /></IconButton>
                                            <IconButton onClick={() => handleCancel("pause", true)} color="red" size="small"><Close /></IconButton>
                                        </Box>
                                    ) : (
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            {pauseData.find(p => p.value === pauseBinome)?.label || "N/A"}
                                            <IconButton onClick={() => handleEditClick("pause", true)} size="small" color="primary"><Edit /></IconButton>
                                        </Box>
                                    )
                                ) : (
                                    <Typography variant="body2" color="textSecondary">Pas de feuille de temps</Typography>
                                )}
                            </TableCell>

                            <TableCell align="center">
                                <Typography sx={WASH_VALUE_SX}>
                                    {data.binome.feuilleDeTemps?.derniereIntervention ? h.getFormattedTime(data.binome.feuilleDeTemps.derniereIntervention) : "-"}
                                </Typography>
                            </TableCell>

                            <TableCell align="center" sx={hasDifference.fin ? { backgroundColor: "rgba(187,34,34,0.7)" } : {}}>
                                {data?.binome?.feuilleDeTemps ? (
                                    <Box display="flex" alignItems="center" justifyContent="center">
                                        {isEditingEndBinome ? (
                                            <>
                                                <DateTimePicker
                                                    label="Heure de fin"
                                                    value={heureFinBinome}
                                                    onChange={(v) => setHeureFinBinome(v)}
                                                    renderInput={(params) => <TextField {...params} size="small" style={{ width: "130px" }} />}
                                                />
                                                <IconButton onClick={() => handleSave("end", true)} color="secondary" size="small"><Check /></IconButton>
                                                <IconButton onClick={() => handleCancel("end", true)} color="red" size="small"><Close /></IconButton>
                                            </>
                                        ) : (
                                            <>
                                                {heureFinBinome ? h.getFormattedTime(heureFinBinome) : "N/A"}
                                                <IconButton onClick={() => handleEditClick("end", true)} size="small" color="primary"><Edit /></IconButton>
                                            </>
                                        )}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="textSecondary">Pas de feuille de temps</Typography>
                                )}
                            </TableCell>

                            <TableCell align="center">
                                {binomeEngineTimesFin ? (
                                    <Typography sx={ENGINE_VALUE_SX}>{binomeEngineTimesFin}</Typography>
                                ) : (
                                    renderLaveuseTimes(data.binome.laveusePrisePoste, data.binome.laveuseFinPoste, binomeEngineTimesDebut, binomeEngineTimesFin, false)
                                )}
                            </TableCell>

                            <TableCell align="center">
                                <Checkbox
                                    checked={!!data?.binome?.panierRepas}
                                    onChange={(e) => handlePanierRepasToggle(e.target.checked, data?.binome?.posteOperateurId)}
                                    disabled={isUpdatingPanier || !data?.binome?.posteOperateurId}
                                    inputProps={{ 'aria-label': 'Panier repas binome' }}
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Box>
    );
}
